import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";

import HNSColors from "../ui library/HNSColors";

export default function OrderingArrow({ orderingVal, setOrderingVal, val }) {
  return (
    <>
      {" "}
      {orderingVal === val ? (
        <IconButton
          onClick={() => setOrderingVal(`-${val}`)}
          className="p-0"
          sx={{ color: HNSColors.primary[500] }}
        >
          <ArrowDropUp />
        </IconButton>
      ) : orderingVal === `-${val}` ? (
        <IconButton
          onClick={() => setOrderingVal(val)}
          className="p-0"
          sx={{ color: HNSColors.primary[500] }}
        >
          <ArrowDropDown />
        </IconButton>
      ) : (
        <IconButton
          onClick={() => setOrderingVal(val)}
          className="p-0"
          sx={{ color: HNSColors.neutrals[500] }}
        >
          <ArrowDropDown />
        </IconButton>
      )}
    </>
  );
}
